import { FC, memo } from 'react';

import { AvatarPlaceholderType } from '@gem/components';
import { InfoCardPlaceholder } from '@gem/components';

import { useSyncAnimations } from '../hooks/useSyncAnimations';

export const GROUPS_PLACEHOLDER_ITEM_SIZE = 64;

export interface IGroupsPlaceholderProps {
  className?: string;
  count?: number;
  avatarType?: AvatarPlaceholderType;
}

export const GroupsPlaceholder: FC<IGroupsPlaceholderProps> = memo((props) => {
  const { className, count = 20, avatarType = AvatarPlaceholderType.Round_10 } = props;
  const { isFirstAnimated, isSecondAnimated } = useSyncAnimations({
    firstTimeout: 500,
    secondTimeout: 1000,
  });

  return Array.from({ length: count }, (_, key) => {
    return (
      <InfoCardPlaceholder
        key={key}
        className={className}
        avatarType={avatarType}
        isSecondAnimated={isSecondAnimated}
        isFirstAnimated={isFirstAnimated}
      />
    );
  });
});
